// extracted by mini-css-extract-plugin
export var container = "_96-0";
export var outlet = "_96-1";
export var outletEnter = "_96-2";
export var outletEnterActive = "_96-3";
export var outletExit = "_96-4";
export var outletExitActive = "_96-5";